import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path d="M10.667 1.336A1.333 1.333 0 009.333 0h-.666a1.333 1.333 0 00-1.334 1.336v12h3.333zM15.333 4A1.333 1.333 0 0014 2.669h-.667A1.333 1.333 0 0012 4v9.333h3.333zM6 6.669a1.333 1.333 0 00-1.333-1.333H4a1.333 1.333 0 00-1.333 1.333v6.667H6zm9.333 8h-14v-14A.667.667 0 000 .667V16h15.333a.667.667 0 000-1.333z" />
  </svg>
);
